import actionTypes from 'constants/countriesConstants';

export function fetchCountries(successCallback = null) {
  return (dispatch, getState, api) => {
    dispatch({ type: actionTypes.FETCH_COUNTRIES_REQUEST });
    api.get('/countries').then(
      response => {
        dispatch({ type: actionTypes.FETCH_COUNTRIES_SUCCESS, payload: response.data });

        if (successCallback) { successCallback(); }
      },
      error => dispatch({ type: actionTypes.FETCH_COUNTRIES_FAILURE, payload: error })
    );
  };
}



// WEBPACK FOOTER //
// app/client/bundles/EventSubmission/actions/countriesActions.js